import { render, staticRenderFns } from "./CustProdInList.vue?vue&type=template&id=6ac024dc"
import script from "./CustProdInList.vue?vue&type=script&lang=js"
export * from "./CustProdInList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports